import React from 'react';

// App-wide "what is the user looking at" context. Report pages populate it; the
// chat hook reads it and attaches it to each turn so the model knows the current
// report/page. Null when the user is on a page with no report context.
//
// context shape (kept small — NO row data; the model reads data via MCP by reportID):
//   { kind, reportID, reportName, activeTab, filters, components, datasetCaches }
// datasetCaches ({ lid: cacheTableName }) is the cache snapshot the report is locked to; the gateway
// forwards these bare table names so the MCP queries the same cache the user sees (not just "newest").
// The builder additionally publishes { kind:'report4-builder', working_definition, availableFields }.
//
// builderApply is a SEPARATE, non-model channel: the report builder registers a callback here
// so ToolResultRenderer can apply an AI-proposed definition in place. It is never serialized into
// the model-facing `context` (a function can't be sent to the gateway).
//
// reloadReport is another non-model channel: the active report (Report2/Report4) registers a
// reload-against-the-newest-cache callback so the chat's "data expired" dialog can rebuild the
// report's pins (which then flow back into `context.datasetCaches`) without a full page reload.
export const ReservoirChatContext = React.createContext({
  context: null,
  setChatContext: () => {},
  builderApply: null,
  setBuilderApply: () => {},
  reloadReport: null,
  setReloadReport: () => {},
});
